<template>
    <b-form-group :label="label" label-for="empresa" class="col-12 col-md-12 px-1 mb-2">
        <div class="empresa-adder d-flex mb-2">
            <InputAutocomplete v-if="!isGroup" :showId="showId" :loader="empresaAutocompleteLoader" v-model="empresaAddition" />
            <InputAutocomplete v-else :showId="showId" :loader="grupoEmpresarialAutocompleteLoader" v-model="empresaAddition" />
            <b-button pill :id="id" @click="addEmpresa"  class="empresa-adder-btn px-2">
                <b-icon-plus class="empresa-adder-btn-plus"/>
                <b-tooltip target="add-empresa" triggers="hover" title="Adicionar Empresa" custom-class="tooltip-item-btn"/>
            </b-button> 
        </div>
        <b-form-invalid-feedback :state="state.empresaAddition">{{validateMessage.empresaAddition}}</b-form-invalid-feedback>

        <b-list-group class="empresa-adder-list row m-0">
            <b-list-group-item v-for="empresa in empresas" :key="empresa.id" 
                class="empresa-adder-list-item mb-2 mr-1 d-flex px-1 py-1">
                {{empresa.text}}
                <b-button pill @click="removeEmpresa(empresa)" class="empresa-adder-list-item-btn-remove">
                    <b-icon-x />
                    <b-tooltip :target="id" triggers="hover" title="Adicionar Empresa" custom-class="tooltip-item-btn"/>
                </b-button>
            </b-list-group-item>
        </b-list-group>
        <b-form-invalid-feedback :state="state.empresa">{{validateMessage.empresa}}</b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import EmpresaResource from "@/resources/EmpresaResource"
import RelatorioResource from "@/resources/RelatorioResource"
import InputAutocomplete from "@/components/commons/Inputs/InputAutocomplete"

export default {
    props: {
        empresas: Array,
        label: String,
        id: String,
        keyString: String, 
        isGroup: Boolean,
        showId: Boolean
    },
    data() {
        return {
            empresaAddition: null,
            validateMessage: {
                empresaAddition: '',
                empresa: ''
            },
            state: {
                empresaAddition: false,
                empresa: false,
                isGroup: false
            }
        }
    },
    components: {
        InputAutocomplete
    },
    
    methods: {
        empresaAutocompleteLoader: EmpresaResource.autocomplete,
        grupoEmpresarialAutocompleteLoader: RelatorioResource.grupo,
        addEmpresa() {
            if (!this.empresaAddition || !this.empresaAddition.id)
                return

            let empresa = {...this.empresaAddition}

            let alreadyAdded = this.empresas.filter(e => e.id == empresa.id).length

            if (!alreadyAdded)
            {
                this.$emit('add', this.keyString, empresa)
                this.empresaAddition = null
            }
        },
        removeEmpresa(empresa) {
            this.$emit('remove', this.keyString, empresa)
        },        
    }
}

</script>